import { KeyValuePair } from '@morningstar/shared/models';

export class HttpParamsHelper {
  static mapToQueryParams<T>(options: T): { [param: string]: string | string[] } {

    const params = { };

    if (options == null) {
      return params;
    }    

    Object.keys(options).forEach(key => {
      if (options[key]) {
        params[key] = options[key].toString();
      }      
    });

    return params;
  }

  static replaceParams(endpoint: string, params: KeyValuePair[]): string {
    params.forEach(p => {
      endpoint = endpoint.replace(p.key, p.value);
    });
    return endpoint;
  }
}